import { render } from "./Index.vue?vue&type=template&id=9831dcde&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=9831dcde&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/b2c-im-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9831dcde"]])

export default __exports__